// Декоративный QR-код для блока «Следить» / футера результата.
//
// Это НЕ настоящий QR (как и в дизайн-прототипе mkQR — чисто визуальный плейсхолдер):
// детерминированный 25×25 паттерн из строки-сида с тремя «глазами» по углам и
// чистой зоной под лого в центре. Достаточно, чтобы воспроизвести визуал v6.
// При необходимости реального сканирования сюда подключается библиотека-кодер.

const GRID = 25;

/** Простой детерминированный хэш строки → 32-бит. */
function hash(str: string): number {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619) >>> 0;
  }
  return h >>> 0;
}

/** Вернуть SVG-разметку декоративного QR заданного размера (px). */
export function qrSvg(seed: string, size = 60): string {
  const cells: string[] = [];
  let state = hash(seed) || 1;
  const rand = () => {
    // xorshift32
    state ^= state << 13; state >>>= 0;
    state ^= state >> 17;
    state ^= state << 5; state >>>= 0;
    return state / 0xffffffff;
  };

  const isFinder = (x: number, y: number) =>
    (x < 7 && y < 7) || (x >= GRID - 7 && y < 7) || (x < 7 && y >= GRID - 7);
  const isQuiet = (x: number, y: number) => {
    const c = (GRID - 1) / 2;
    return Math.abs(x - c) <= 3 && Math.abs(y - c) <= 3; // чистая зона под лого
  };

  for (let y = 0; y < GRID; y++) {
    for (let x = 0; x < GRID; x++) {
      if (isFinder(x, y) || isQuiet(x, y)) continue;
      if (rand() > 0.52) cells.push(`<rect x="${x}" y="${y}" width="1" height="1"/>`);
    }
  }

  // Три «глаза»-локатора.
  const eye = (ox: number, oy: number) => `
    <rect x="${ox}" y="${oy}" width="7" height="7" fill="none" stroke="#0B0B0A" stroke-width="1"/>
    <rect x="${ox + 2}" y="${oy + 2}" width="3" height="3" fill="#0B0B0A"/>`;

  return `
    <svg viewBox="0 0 ${GRID} ${GRID}" width="${size}" height="${size}" shape-rendering="crispEdges" aria-hidden="true">
      <g fill="#0B0B0A">${cells.join('')}</g>
      ${eye(0, 0)}${eye(GRID - 7, 0)}${eye(0, GRID - 7)}
    </svg>`;
}
